module.exports = __webpack_public_path__ + "static/media/S1-7-Beltrozz-cod7.50af66bf.png";